import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModalOfflineComponent } from './modal-offline.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalButton } from '@app/common/models/modal-button';

@Injectable({
  providedIn: 'root'
})
export class ModalOfflineService {
  bsModalRef: BsModalRef;

  constructor(
    private bsModalService: BsModalService,
  ) { }

  confirm(title: string): Observable<string> {
    const initialState = {
      title: title,
      message: '',
      options: '',
      answer: '',
    };
    this.bsModalRef = this.bsModalService.show(ModalOfflineComponent, { initialState, class: 'modal-dialog-centered', backdrop: 'static' });

    return new Observable<string>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer) => {
      const subscription = this.bsModalService.onHidden.subscribe((reason: string) => {
        observer.next(this.bsModalRef.content.answer);
        observer.complete();
      });

      return {
        unsubscribe() {
          subscription.unsubscribe();
        }
      };
    };
  }
}
